export default __webpack_public_path__ + "static/media/@carolvilarica.a3d0c998.png";